import type { ExecutionMatrixRow, SchemeExecutionCell } from "@/types/client";

export interface BuildTableParams {
  buyResults: ExecutionMatrixRow[];
  sellResults: ExecutionMatrixRow[];
  schemes: string[];
  cmpData: Record<number, number | null>;
  getDifference: (companyId: number, limitPrice: number, orderSide: 1 | 2) => { value: number; pct: number } | null;
}

export const FIXED_COLUMN_LABELS = ["Company", "Limit Price", "CMP", "Diff", "Diff%", "POV%"] as const;
export const SCHEME_SUB_LABELS = ["Order", "Exec", "POV%"] as const;

export function formatRowPov(row: ExecutionMatrixRow): string {
  return row.pov_error ? row.pov_error : String(row.total_pov_percentage ?? "");
}

export function formatCellPov(cell: SchemeExecutionCell): number | string {
  return cell.is_pov_excluded || cell.pov_percentage == null ? "" : cell.pov_percentage;
}
